export default {
  uso: 1,
  privacidade: 2
}
